/**
 * 描述：机器人稿
 * 日期：2017-8-22
 * 作者：Bai.Zhiming
 */
"use strict";
angular.module("resCenRobotLeftModule", [])
    .directive("robotLeft", ["$state", "resourceCenterService", "$q", "$timeout", "$stateParams", "trsHttpService", function($state, resourceCenterService, $q, $timeout, $stateParams, trsHttpService) {
        return {
            replace: false,
            restrict: "E",
            scope: {
                firstNav: "="
            },
            templateUrl: "./networkResource/featuredResource/robot/left/left_tpl.html",
            link: function($scope, $elem, $attrs) {
                initStatus();
                initData();
                /**
                 * [initStatus description] 初始化状态
                 * @return {[type]} [description]
                 */
                function initStatus() {
                    $scope.status = {};
                    $scope.data = {};
                }
                /**
                 * [initData description] 初始化数据
                 * @return {[type]} [description]
                 */
                function initData() {
                    autoLocation();
                }
                /**
                 * [autoLocation description] 自动定位
                 * @param {object} [items] [description] 一级父分类
                 * @return {Boolean} [description]
                 */
                function autoLocation() {
                    if ($stateParams.onlyExpand) {
                        goTo($scope.firstNav[0]);
                        return;
                    }
                    var flag = false;
                    for (var i in $scope.firstNav) {
                        var nav = $scope.firstNav[i];
                        if ($stateParams.nodeid === nav.id) {
                            flag = true;
                            $scope.status.selectedNav = nav;
                            break;
                        }
                        for (var j in nav.CHILDREN) {
                            var child = nav.CHILDREN[j];
                            if (child.id === $stateParams.nodeid) {
                                flag = true;
                                $scope.status.parentNode = nav;
                                $scope.status.parentNode.isOpen = true;
                                $scope.status.selectedNav = child;
                                break;
                            }
                        }
                    }
                    if (!flag) {
                        goTo($scope.firstNav[0]);
                    }
                }
                /**
                 * [firstNavSelected description] 判断一级菜单是否选中
                 * @param {object} [items] [description] 一级菜单
                 * @return {[type]} [description]
                 */
                $scope.firstNavSelected = function(items) {
                    if ($scope.status.selectedNav != undefined) {
                        return items.id === $scope.status.selectedNav.id ? 'active' : '';
                    } else {
                        return "";
                    }
                };
                /**
                 * [clickFirst description] 点击一级分类
                 * @return {[type]} [description] 一级分类信息
                 */
                $scope.clickFirst = function($event, item) {
                    if ($event !== "") $event.stopPropagation();
                    goTo(item);
                };
                /**
                 * [clickSecond description] 点击二级分类
                 * @param {object} [item] [description] 二级分类信息
                 * @return {[type]} [description]
                 */
                $scope.clickSecond = function($event, item, items) {
                    if ($event !== "") $event.stopPropagation();
                    $scope.status.parentNode = items;
                    goTo(item);
                };
                /**
                 * [childIsSelected description] 子节点是否被选中
                 * @param {object} [items] [description] 一级父分类
                 * @return {[type]} [description]
                 */
                $scope.childIsSelected = function(items) {
                    if (!items.CHILDREN) return '';
                    return items.CHILDREN.indexOf($scope.status.selectedNav) >= 0 ? 'on' : '';
                };
                /**
                 * [expandSecond description] 展开二级分类
                 * @param {object} [items] [description] 一级父分类
                 * @return {[type]} [description]
                 */
                $scope.expandSecond = function($event, items) {
                    if ($event !== "") $event.stopPropagation();
                    items.isOpen = !items.isOpen;
                };
                /**
                 * [hideAllSecond description]
                 * @return {[type]} [description]
                 */
                function hideAllSecond() {
                    if ($scope.firstNav.length > 0) {}
                }
                /**
                 * [goTo description] 路由切换
                 * @return {[type]} [description]
                 */
                function goTo(item) {
                    $scope.status.selectedNav = item;
                    resourceCenterService.go("front.networksource.featuredresource.robot.resource", {
                        typename: "jqrg_ztfl",
                        nodeid: item.id,
                        nodename: item.dictName,
                        //parentid: parentid,
                        //change: Math.random(0, 1) * 100
                    });
                }
            }
        };
    }]);